import React from "react";
import { useNavigate } from "react-router-dom";
import '../../assets/css/style.css';
import HedDan from "./Header";
import BackArow from '../../assets/img/back.svg';
import { useEffect } from "react";
import { useState } from "react";



const TransactionsDan = () => {

  

    const navigate = useNavigate();
    const [transactions, setTransactions] = useState([]);


    useEffect(() => {
      const token = localStorage.getItem("donetoken");
      if (token) {
          fetch(`https://app.doneapp.ir/backend/view_transactions.php?token=${token}`)
              .then(res => res.json())
              .then(data => {
                  if (data.status === "success") {
                      setTransactions(data.transactions);
                  } else {
                      alert("خطا در دریافت تراکنش‌ها");
                  }
              })
              .catch(err => console.error("خطا:", err));
      } else {
          alert("وارد حساب خود شوید!");
          navigate("/login");
      }
  }, []);



  return (
    <>
<HedDan />
    
   <div className="mohtava-mine" >
     
 <section id="transactions" className="dir-r max-cntt-w v-100" >
 <div className="reflist-div-1 mt-30" >
            <div className="d-flex"  >
        <p className="reflist-p-1" onClick={() => navigate("/panel/cards")}  >
        سوابق تراکنش
          </p>
        
        
        <img src={BackArow} className="reflist-img-1" alt="back" onClick={() => navigate("/panel/cards")}   />
        </div>

       

        </div>
        <div className="shops-div-1 " >
    <div className="shops-div-2" >

<select className="shop-filter-1" >
<option value="1">آخرین تراکنش‌ها</option>
</select>       


<select className="shop-filter-2" >
<option value="1">تمام سوابق</option>


</select></div>



{transactions.length > 0 ? (
  transactions.map((tx, index) => (
 <div key={index} className={tx.tx_type === "1" ? "tx-variz-div" : "tx-bardasht-div"}>
    <p className="tx-p-1">
     {tx.tx_type === "1" ? `واریز مبلغ ${tx.tx_amount.toLocaleString()} ریال` : `برداشت مبلغ ${tx.tx_amount.toLocaleString()} ریال`}
       </p>
  <p className="tx-p-1">{tx.tozihat}</p>
      <p className="tx-p-1">{tx.tx_date}</p>
      </div>
                            ))
                        ) : (
                            <p className="mt-30" >تراکنشی یافت نشد</p>
                        )}



                    </div>
                </section>
 
   </div>
    </>
       
   );
};

export default TransactionsDan;
